import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';
const AuscultateUI = (props: UIProperties<AuscultateUIConfig>) => {
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%',
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '550px',
				height: '400px',
				pointerEvents: 'all'
			}}>
				<div style={{
					width: '100%',
					height: '400px',
					position: 'relative',
					top: '0',
					left: '0'
				}}>
					<img style={{
						position: 'absolute',
						width: '100%',
						height: '100%'
					}} src="./assets/images/general/window_modal_2.png"/>
					<div style={{

					}}>
						{props.parameters.buttons.map((button: AuscultateButtonUIConfig, index: number) => {
							var id = index === props.parameters.buttons.findIndex((e) => !e.isDisabled) ? 'auscultate-ui-top' : '';
							
							
							return (
								<CustomAuscultateButton 
									id={id}
									position={{
										type: 'relative',
										left: '20px',
										top: '20px'
									}}
									isDisabled={button.isDisabled}
									text={button.title}
									onClicked={() => {
										button.onClicked();
									}}
								/>
							)
						})}
						{props.parameters.showPatentAirwayMessage ? (null) : <div tabIndex={0} id="auscultate-ui-bottom" aria-label="end of content" role="text"></div>}
					</div>
				</div>
				
				{props.parameters.showPatentAirwayMessage ? (<div style={{
					width: '100%',
					height: '210px',
					position: 'relative',
					top: '0',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '70px'
					}} src="./assets/images/SBAR/header_modal_1.png"/>
					<div style={{
						position: 'absolute',
						top: '01px',
						left: '3px',
						width: '543px',
						height: '65px',
					}}>
						<p style={{
							margin: '0px',
							fontSize: '18pt',
							textAlign: 'center',
							position: 'relative',
							top: '6px'
						}} className="title-font" id="auscultate-ui-top" tabIndex={0}>Do you have a patent airway?</p>
						<p style={{
							margin: '0px',
							fontSize: '15pt',
							textAlign: 'center',
							position: 'relative',
							fontWeight: 'normal',
							top: '6px'
						}} className="title-font" tabIndex={0}>(i.e. Is the patient in the green zone?)</p>
					</div>
					<div style={{
						width: '100%',
						height: '140px',
						position: 'absolute',
						top: '70px',
						left: '0'
					}}>
						<img style={{
							width: '100%',
							height: '100%'
						}} src="./assets/images/SBAR/window_modal_1_edited.png"/>

						<GeneralButtonWithText parameters= {{
							text: 'Yes',
							ariaLbl: 'Yes',
							top: '30px',
							left: '110px',
							width: '140px',
							isDisabled: false,
							srcIdle: "./assets/images/main-menu/button_menu_exit.png",
							srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
							srcDisabled: null,
							customImgStyle: {
							},
							customButtonStyle : {
							},
							customTextStyle: {
								fontSize: '12pt'
							},
							onClicked: () => {
								props.parameters.onPatentAirwayYesClicked();
							}
						}}/>
						<GeneralButtonWithText parameters= {{
							text: 'No',
							ariaLbl: 'No',
							id: 'auscultate-ui-bottom',
							top: '30px',
							left: '300px',
							width: '140px',
							isDisabled: false,
							srcIdle: "./assets/images/main-menu/button_menu_exit.png",
							srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
							srcDisabled: null,
							customImgStyle: {
							},
							customButtonStyle : {
							},
							customTextStyle: {
								fontSize: '12pt'
							},
							onClicked: () => {
								props.parameters.onPatentAirwayNoClicked();
							}
						}}/>
						
					</div>
				</div>) : (null)}
			</div>
		</div>
	);

};

const CustomAuscultateButton = (props: CustomAuscultateButtonConfig) => {
	const [isClicked, setIsClicked] = useState(props.isDisabled);
	return (
		<div style={{
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: '500px',
			height: '123px',
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'relative'
			}}>
				<GeneralButtonWithText parameters= {{
					text: '',
					top: '0px',
					id: props.id,
					left: '0px',
					isDisabled: props.isDisabled,
					ariaLbl: props.text,
					width: '170px',
					srcIdle: './assets/images/general/buttons/bar_modal_1.png',
					srcHighlight: null,
					srcDisabled: null,
					customMainStyle: {
						// position: 'relative',
						// width: props.isFlipped ? '99px' : '129px',
						// transform: props.isFlipped ? 'scaleX(-1)' : 'scaleX(1)'
					},
					onClicked: () => {
						setIsClicked(true);
						if(props.onClicked) {
							props.onClicked();
						}
					}
				}}/>
				
				<div style={{
					position: 'relative',
					height: '30px',
					pointerEvents: 'none',
					width: '85%',
					left: '12px',
					top: '47px'
				}}>
					<div style={{
						position: 'relative',
						top: '50%',
						transform: 'translate(0, -50%)'
					}}>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '16pt',
							fontWeight: 'normal'
						}}>{props.text}</p>
					</div>
					
				</div>

				<img style={{
					position: 'absolute',
					top: '10px',
					right: '-9px',
					width: '75px',
					pointerEvents: 'none'
				}} src={"./assets/images/general/buttons/" + (isClicked ? "bar_modal_down_checked" : "bar_modal_down") + ".png"} />
			</div>
		</div>
	);

};

interface CustomAuscultateButtonConfig {
	text: string;
	id?: string;
	ariaLbl?: string;
	isDisabled: boolean;
	position: CustomAuscultateButtonPosition;
	onClicked?: () => void;
}

interface CustomAuscultateButtonPosition {
	type?: any;
	left: string;
	top: string;
}

export interface AuscultateUIConfig extends BaseConfig{
	buttons: AuscultateButtonUIConfig[];
	showPatentAirwayMessage?: boolean;
	onPatentAirwayYesClicked?: () => void;
	onPatentAirwayNoClicked?: () => void;
}

export interface AuscultateButtonUIConfig extends BaseConfig{
	title: string;
	isDisabled: boolean;
	onClicked: () => void;
}

export default AuscultateUI;